import axios from 'axios';
import apiUrl from '../../../constants'

export default new class {
	async getAdminSettings(input) {
			 try {
					 let result = await axios({
							 method: 'POST',
							 'url': apiUrl.api_url + 'adminsettings/getsettings',
							 'data': input,
					 })
					 return result;
			 } catch (err) {
					 throw new Error(err);
			 }
	 };
	 async saveAdminSettings(input) {
			 try {
					 let result = await axios({
							 method: 'POST',
							 'url': apiUrl.api_url + 'adminsettings/savesettings',
							 'data': input,
					 })
					 return result;
			 } catch (err) {
					 throw new Error(err);
			 }
	 };
	 async getODApincodeDetails(input) {
		 try {
			 let result = await axios({
				 method: 'POST',
				 'url': apiUrl.api_url + 'cargomaster/odaPincodeList',
				 'data': input,
			 })
			 return result;
		 } catch (err) {
			 throw new Error(err);
		 }
	 };
	 async createODAPincode(input) {
		 try {
			 let result = await axios({
				 method: 'POST',
				 'url': apiUrl.api_url + 'cargomaster/createOdapincode',
				 'data': input,
			 })
			 return result;
		 } catch (err) {
			 throw new Error(err);
		 }
	 };
	 async createDTHhubMapping(input) {
		try {
			let result = await axios({
				method: 'POST',
				'url': apiUrl.api_url + 'cargotripmanagement/savedthmappingconfig',
				'data': input,
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	};
	async getDTHhubMappingList(input) {
		try {
			let result = await axios({
				method: 'POST',
				'url': apiUrl.api_url + 'cargotripmanagement/getdthhubmapping',
				'data': input,
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	};
	async getDTHtriplogList(input) {
		try {
			let result = await axios({
				method: 'POST',
				'url': apiUrl.api_url + 'cargotripmanagement/getdthlogs',
				'data': input,
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	};
	async GetDTHCapacityThreshold(input) {
		try {
			let result = await axios({
				method: 'POST',
				'url': apiUrl.api_url + 'cargotripmanagement/getdthcapacitythreshold',
				'data': input,
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	};
	async DownloadDTHLogs(input) {
		try {
			let result = await axios({
				method: 'POST',
				'url': apiUrl.api_url + 'cargotripmanagement/getalldthlogs',
				'data': input,
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	};
	async saveClientSettings(input){
		try {
			let result = await axios({
					method: 'POST',
					'url': apiUrl.api_url + 'clientsettings/saveclientsettings',
					'data': input,
			})
			return result;
			} catch (err) {
					throw new Error(err);
			}
	 };
	 async getClientSettings(input){
		try {
			let result = await axios({
					method: 'POST',
					'url': apiUrl.api_url + 'clientsettings/getclientsettings',
					'data': input,
			})
			return result;
			} catch (err) {
					throw new Error(err);
			}
	 };
	 async getAllKeyClient(input){
		try {
			let result = await axios({
					method: 'POST',
					'url': apiUrl.api_url + 'clientsettings/getallclient',
					'data': input,
			})
			return result;
			} catch (err) {
					throw new Error(err);
			}
	 };
	 async getConfigureClient(input){
		try {
			let result = await axios({
					method: 'POST',
					'url': apiUrl.api_url + 'clientsettings/getconfigureclient',
					'data': input,
			})
			return result;
			} catch (err) {
					throw new Error(err);
			}
	 };
	 async createHTDhubMapping(input) {
		try {
			let result = await axios({
				method: 'POST',
				'url': apiUrl.api_url + 'cargotripmanagement/savehtdmappingconfig',
				'data': input,
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	};
	async getHTDhubMappingList(input) {
		try {
			let result = await axios({
				method: 'POST',
				'url': apiUrl.api_url + 'cargotripmanagement/gethtdhubmapping',
				'data': input,
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	};
	async getOpenPickupDeliveryClientst(input){
		try {
			let result = await axios({
					method: 'POST',
					'url': apiUrl.api_url + 'clientsettings/getopenpickupdeliveryclient',
					'data': input,
			})
			return result;
			} catch (err) {
					throw new Error(err);
			}
	 };	
}



// WEBPACK FOOTER //
// ./src/modules/adminsettings/services/adminsettings.service.js